import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import { SignInButton, useClerk, useAuth } from '@clerk/clerk-react';

const J = {
    surface: '#111827',
    border: '0.5px solid #294766',
    muted: '#a3d1ff',
    accent: '#66b2ff',
};

const publicNavItems = ['Features', 'Guide', 'FAQ', 'Blog'];

// Experimental/rarely-used pages, grouped under Proto's
const protoItems = [
    { label: 'Designer', path: '/designer' },
    { label: 'Bookshelf', path: '/bookshelf' },
    { label: 'CurrentState', path: '/currentstate' },
    { label: 'Klippy', path: '/klippy' },
];

/**
 * Mobile drawer for AppBar navigation.
 * @param {boolean} open - Drawer open state
 * @param {function} onClose - Called when drawer should close
 */
export default function AppBarDrawer({ open, onClose }) {
    const navigate = useNavigate();
    const { signOut } = useClerk();
    const { userId } = useAuth();
    const isSignedIn = !!userId;

    const navItems = isSignedIn ? [...publicNavItems, 'Dashboard'] : publicNavItems;

    return (
        <Drawer anchor="top" open={open} onClose={onClose}>
            <Box sx={{ p: 2, bgcolor: J.surface }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <IconButton onClick={onClose} sx={{ color: J.muted }}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Box>

                {navItems.map((item) => (
                    <MenuItem
                        key={item}
                        onClick={() => {
                            navigate(`/${item.toLowerCase()}`);
                            onClose();
                        }}
                        sx={{ color: J.muted }}
                    >
                        {item}
                    </MenuItem>
                ))}

                {isSignedIn && import.meta.env.DEV && (
                    <>
                        <Divider sx={{ my: 1, borderColor: '#294766' }} />
                        {protoItems.map(({ label, path }) => (
                            <MenuItem
                                key={path}
                                onClick={() => {
                                    navigate(path);
                                    onClose();
                                }}
                                sx={{ color: J.muted }}
                            >
                                {label}
                            </MenuItem>
                        ))}
                    </>
                )}

                <Divider sx={{ my: 2, borderColor: '#294766' }} />

                {isSignedIn ? (
                    <MenuItem>
                        <Button
                            onClick={() => {
                                console.log('signOut');

                                signOut();
                            }}
                            fullWidth
                            sx={{ color: J.accent, border: J.border }}
                        >
                            Sign out
                        </Button>
                    </MenuItem>
                ) : (
                    <MenuItem>
                        <SignInButton>
                            <Button fullWidth sx={{ color: J.muted, border: J.border }}>
                                Sign in
                            </Button>
                        </SignInButton>
                    </MenuItem>
                )}
            </Box>
        </Drawer>
    );
}
